// 페이지 권한 매핑 상수
export const PAGE_PERMISSION_MAP = {
  // 오더관리
  '오더관리': {
    '오더 입력': '/main/orders/input',
    '오더 수정': '/main/orders/modify', 
    '오더 현황': '/main/orders/work-order',
    '검색': '/main/orders/search',
    'Swatch 관리': '/main/orders/swatch-management',
    '인보이스 발급': '/main/orders/invoice-issuance',
    '인보이스 관리': '/main/orders/invoice-management'
  },
  
  // 염색관리
  '염색관리': {
    '염색 작업': '/main/dyeing/operation',
    '염색 현황': '/main/dyeing/status',
    '레시피 검색': '/main/dyeing/recipe-search'
  },
  
  // 와인딩 관리
  '와인딩 관리': {
    '와인딩 작업': '/main/winding/operation',
    '와인딩 현황': '/main/winding/status'
  },
  
  // 출고 관리
  '출고 관리': {
    '출고 작업': '/main/shipping/operation',
    '출고 추적': '/main/shipping/tracking'
  },
  
  // 작업 요청
  '작업 요청': {
    '염색 요청': '/main/dyeing/work',
    '와인딩 요청': '/main/winding/request',
    '출고 요청': '/main/shipping/request'
  },
  
  // 재무 관리
  '재무 관리': {
    '매출 관리': '/main/finance/payment-management'
  },
  
  // 재고 관리
  '재고 관리': {
    '재고 잔고 조회': '/main/inventory/balance',
    'LOT 조회': '/main/inventory/lot-batch',
    '재고 변동 조회': '/main/inventory/transaction-history',
    '재고 조정': '/main/inventory/adjustment',
    '일괄 입력': '/main/inventory/batch-input'
  },
  
  // 공급망 관리
  '공급망 관리': {
    '입고 등록': '/main/scm/goods-receipt',
    '출고 등록': '/main/scm/goods-issue-registration',
    '출고 현황': '/main/scm/goods-issue-list',
    '배송 등록': '/main/scm/delivery-info',
    '배송 현황': '/main/scm/delivery-status'
  },
  
  // 주 데이터
  '주 데이터': {
    '품목': '/main/master/item',
    'UOM & 환산': '/main/master/uom-conversion',
    '창고 위치': '/main/master/location',
    '공급자 등록': '/main/master/supplier',
    '품목 분류': '/main/master/item-taxon',
    '거래처': '/main/master/customer',
    '바이어': '/main/master/buyer'
  },
  
  // 관리자
  '관리자': {
    '사용자 관리 - 회원가입관리': '/main/admin/users/registration',
    '사용자 관리 - 비밀번호 재설정': '/main/admin/users/reset-password',
    '사용자 관리 - 접속 로그 확인': '/main/admin/users/access-logs',
    '사용자 관리 - 메시지 보내기': '/main/admin/users/send-message',
    '기준정보 관리 - 아이템 관리': '/main/admin/standards/threads',
    '기준정보 관리 - 거래처 관리': '/main/admin/standards/companies',
    '기준정보 관리 - 바이어 관리': '/main/admin/standards/buyers',
    '기준정보 관리 - 단가 관리': '/main/admin/standards/prices',
    '기준정보 관리 - 길이(M) 관리': '/main/admin/standards/sizes',
    '기준정보 관리 - 기계 관리': '/main/admin/standards/machine',
    '자재 관리 - 원사 관리': '/main/admin/materials/yarn',
    '자재 관리 - 염료 관리': '/main/admin/materials/dye',
    '자재 관리 - 재고 관리': '/main/admin/materials/inventory'
  }
};

// 메뉴 구조와 권한 매핑 (언어에 무관한 키 사용)
export const MENU_PERMISSION_MAP = {
  // 공지사항은 항상 표시
  'notices': null,
  
  // 오더 관리
  'orderManagement': '오더관리',
  
  // 염색 관리  
  'dyeingManagement': '염색관리',
  
  // 와인딩 관리
  'windingManagement': '와인딩 관리',
  
  // 출고 관리
  'shippingDelivery': '출고 관리',
  
  // 작업 요청
  'workRequest': '작업 요청',
  
  // 재무 관리
  'financeManagement': '재무 관리',
  
  // 재고 관리
  'inventoryManagement': '재고 관리',
  
  // 공급망 관리
  'scmManagement': '공급망 관리',
  
  // 주 데이터
  'masterData': '주 데이터',
  
  // 관리자
  'admin': '관리자'
};

// 언어별 메뉴 제목 매핑
export const MENU_TITLE_MAP = {
  ko: {
    'notices': '공지사항',
    'orderManagement': '오더 관리',
    'dyeingManagement': '염색 관리',
    'windingManagement': '와인딩 관리',
    'shippingDelivery': '출고 관리',
    'workRequest': '작업 요청',
    'financeManagement': '재무 관리',
    'inventoryManagement': '재고 관리',
    'scmManagement': '공급망 관리',
    'masterData': '주 데이터',
    'admin': '관리자'
  },
  en: {
    'notices': 'Notices',
    'orderManagement': 'Order',
    'dyeingManagement': 'Dyeing',
    'windingManagement': 'Winding',
    'shippingDelivery': 'Delivery',
    'workRequest': 'Work Request',
    'financeManagement': 'Finance Management',
    'inventoryManagement': 'Inventory Management',
    'scmManagement': 'SCM',
    'masterData': 'Master Data',
    'admin': 'Admin'
  },
  id: {
    'notices': 'Pemberitahuan',
    'orderManagement': 'Order',
    'dyeingManagement': 'Dyeing',
    'shippingDelivery': 'Pengiriman',
    'windingManagement': 'Winding',
    'workRequest': 'Permintaan Kerja',
    'financeManagement': 'Manajemen Keuangan',
    'inventoryManagement': 'Manajemen Inventori',
    'scmManagement': 'SCM',
    'masterData': 'Master Data',
    'admin': 'Admin'
  }
};
